/** Filename suffix of the funding manual PDF served from the app's public root. */
const FUNDING_MANUAL_VERSION = "version13";

/** The funding manual PDF is always served under `/assets`, independent of the router basename. */
const FUNDING_MANUAL_BASE_PATH = "/assets";

/**
 * Builds the funding manual PDF URL, deep-linking to a policy's section via
 * the PDF's named destination when a policyTag is present.
 * @param {string} [policyTag] - The stipulation's policyTag, matching a named destination in the PDF.
 * @returns {string} The funding manual URL, opened with the toolbar/navpanes hidden.
 */
export function fundingManualUrl(policyTag?: string): string {
  const anchor = policyTag
    ? `#nameddest=${encodeURIComponent(policyTag)}&toolbar=0&navpanes=0`
    : "#toolbar=0&navpanes=0";
  return `${FUNDING_MANUAL_BASE_PATH}/FundingManual-${FUNDING_MANUAL_VERSION}.pdf${anchor}`;
}
